import * as api from 'api/vendors'
import { useEffect, useState, useMemo } from 'react'

function useVendors(useConcur: boolean) {
  const [vendors, setVendors] = useState<api.Vendor[]>([])
  const [vendorNotFound, setVendorNotFound] = useState(false)

  useEffect(() => {
    if (!useConcur) {
      return
    }
    api.getVendors().then((d) => {
      setVendors(d || [])
      if (!d || d.length === 0) setVendorNotFound(true)
    })
  }, [useConcur])
  const vendorOptions = useMemo(
    () =>
      vendors.map((vendor) => ({
        ...vendor,
        label: `${vendor.vendor_name} (${vendor.vendor_code})`,
        billFromCompanyName: vendor.vendor_name,
        vendorCode: vendor.vendor_code,
        billFromPersonName:
          `${vendor.contact_last_name} ${vendor.contact_first_name}`.trim(),
        billFromPostalCode: vendor.postal_code,
        billFromAddress: ['state', 'city', 'address1', 'address2', 'address3']
          .map((key) => vendor[key] || '')
          .join(' ')
          .trim(),
        billFromTel: vendor.contact_phone_number,
        billFromAddressCode: vendor.address_code,
        billFromCompanyId: vendor.tax_id,
      })),
    [vendors],
  )

  if (!useConcur) {
    return {
      vendors: [],
      vendorNotFound,
    }
  }
  return {
    vendors,
    vendorOptions,
    vendorNotFound,
  }
}

export default useVendors
